export const PR_CONST = {
  PROJECT_REGISTER: "project-register",
  ACTIONS: {
    ADD_PR: "Add New Project",
  },
  FIELDS: {
    PROPSPECT_CONTACT: "Prospect's Contact",
    CUSTOMER_CONTACT: "Customer's Contact",
    PROPSPECT_PROJECT_NUMBER: "Prospect Project Number",
    CUSTOMER_PROJECT_NUMBER: "Customer Project Number",
    PROPSPECT_PROJECT_NAME: "Prospect Project Name",
    PROJECT_NAME: "Project Name",
    REFERENCE_NUMBER: "Reference Number",
    OUR_REFERENCE_NUMBER: "Our Reference Number",
  },
};

export enum PR_ENUM {
  LEADS = "LEADS",
  PROJECT_REGISTER = "Project Register",
  ALL = "ALL",
  ADD = "ADD",
  UPDATE = "UPDATE",
  DOCKET = "DOCKET",
  GROUP = "GROUP",
  ESTIMATION = "ESTIMATION",
  DRIVE = "Drive",
  SUBMITTED = "SUBMITTED",
}

export enum PR_STATUS {
  ALL = "ALL",
  ONGOING = "ONGOING",
  WON = "WON",
  ARCHIVE = "ARCHIVE",
}
export enum PR_CUSTOMER_TYPE {
  CUSTOMER = "CUSTOMER",
  PROSPECT = "PROSPECT",
}

export const PR_Message = {
  PR_TABLE_UPDATED: "Project Register Table Updated",
  PR_DRIVE_UPDATED: "Drive Table Updated",
  PR_ADDED: "New Project Register added successfully",
  PR_NOT_EXITS: "New Project Register does not exist",
  PR_UPDATED: "Project Register updated successfully",
  MAKE_CHANGE: "Please make update",
  SOMETHING_WRONG: "Something went wrong, please try again later",
  ADD_PR: "Add New Project Register",
  ADD_PR2: "Add New Project",
  UPDATE_PR: "Update Project Register",

  PR_OPTION_ADDED: "New Project Register Option Added Successfully",
  PR_DOCUMENT_DELETED: "Project Register Document Deleted Successfully",

  PR_OR_ESTIMATE_NOT_EXIST: "Project Register or Estimate does not exist",
  PR_NOTES_UPDATED: "Project Register notes updated successfully",
  PR_FOLLOW_NOTE_UPDATED:
    "Project Register followup notes updated successfully",

  NO_PR_FOUND: "No Project Register found",
  ADD_NEW_PR: "Add a new Project Register to get started",

  PR_STATUS_UPDATED: "Project Register status updated successfully",
  PR_STATUS_ADDED: "Project Register status added successfully",
  PR_STATUS_DELETED: "Project Register status deleted successfully",
  PR_SUBMITTED: "Project Register submitted successfully",

  NO_CHANGE: "Please make some changes to update",

  CLIENT_CONTACT_UPDATED: "Client contact updated successfully",
  FOLDER_ADDED: "Folder added successfully",
  FOLDER_NAME_REQUIRED: "Folder name is required",

  NO_MARK_SELECT_CUSTOMER: "Cannot mark as done. Please select a customer.",
  ESTIMATE_NOT_FINALIZED:
    "Cannot mark as done. Please finalize the project estimates.",
};

export const Estimation_Message = {
  STATUS_UPDATED: "Estimation status updated successfully",
  STATUS_ADDED: "Estimation status added successfully",
  STATUS_DELETED: "Estimation status deleted successfully",

  SUBMISSION_STATUS_UPDATED:
    "Estimation submission method status updated successfully",
  SUBMISSION_STATUS_ADDED:
    "Estimation submission method status added successfully",
  SUBMISSION_STATUS_DELETED:
    "Estimation submission method status deleted successfully",

  OPTION_ADDED: "Option added successfully",
  OPTION_UPDATED: "Option updated successfully",
  OPTION_DELETED: "Option deleted successfully",

  FINAL_QUOTE_SET: "Final quote set successfully",
  UN_FINAL_QUOTE_SET: "Un-Finalized Quote successfully.",
  ARCHIVED: "Estimate archived successfully",
  ACTIVATED: "Estimate activated successfully",

  EXPORT_IN_PROGRESS: "Export Estimates In Progress",
};

export const EmptyEstimationTableMessage = {
  SUBTITLE: "Add new Estimation.",
  BTN_LABEL: "Add Estimation",
};

export const EstimationActions = {
  ADD: "Add Estimation",
  REVIEW: "Review Estimation",
  EXPORT: "Export Estimates",
  EDIT: "Edit Estimate",
};

export const hiddenAmountSign = "XXXX";

export const ProjectRegisterKeys = {
  Id: "id",
  lastReferenceNumber: "lastReferenceNumber",
};

export const PR_FILTER_KEYS = [
  "dateRange",
  "customerId",
  "prospectId",
  "search",
  "limit",
  "offset",
  "currentPage",
  "sortBy",
  "orderBy",
];

export enum FollowUpIntervals {
  EVERY_DAY = "EVERY_DAY",
  EVERY_WEEK = "EVERY_WEEK",
  EVERY_MONTH = "EVERY_MONTH",
}

export enum ProjectRegisterLocalStorageKeys {
  PROJECT_REGISTER_SHEET_DATA = "projectRegisterSheetData",
}
